import React, { useEffect, useState, useCallback } from "react"
import { Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { showNotificationWithTimeout } from "../../_actions/adminAlertActionCreator"
import { logInUser } from "../../_actions/userActionCreator"
import Loader from "../../common/Loader"
import { API } from "../../api"
import {
  getCachedData,
  getSessionData,
  cacheData,
  sessionData,
  ROUTES
} from "../../common/utils"
import queryString from "query-string"

function SubscriptionSuccess(props) {
  const [fetching, setFetching] = useState(true)

  const params = queryString.parse(props.location.search)
  const subsID = params.subscription_id
  const { logIn, showAlert, status } = props
  const getSubDetails = useCallback(
    async function getSubDetails() {
      try {
        const accountStatus = await API.post(
          "/accounts/subscribe/check_status",
          JSON.stringify({ subscription_id: subsID })
        )
        if (accountStatus && accountStatus.data) {
          const userData =
            getCachedData("Qarabao_User") || getSessionData("Qarabao_User")
          const newUserData = { ...userData, account: accountStatus.data }
          cacheData("Qarabao_User", newUserData)
          sessionData("Qarabao_User", newUserData)
          logIn && logIn(newUserData)
        }
      } catch (error) {
        console.log(error)
      }
    },
    [logIn, subsID]
  )

  useEffect(
    () => {
      getSubDetails()
    },
    [getSubDetails]
  )

  useEffect(
    () => {
      if (status === "SUBSCRIBED") {
        showAlert &&
          showAlert({
            message: "Account successfully upgraded.",
            type: "success",
            consumer: "admin"
          })
        setFetching(false)
      }
    },
    [status, showAlert]
  )

  return <div>{fetching ? <Loader /> : <Redirect to={ROUTES.ADMIN} />}</div>
}
const mapDispatchToProps = dispatch => ({
  showAlert: alert => {
    showNotificationWithTimeout(dispatch, alert)
  },
  logIn: user => {
    dispatch(logInUser(user))
  }
})

const mapStateToProps = state => ({
  status:
    (state && state.user && state.user.account && state.user.account.status) ||
    null
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionSuccess)
